import React from "react";
import "../../src/App.css";

function FAQ() {
  return (
    <div className="page-content">
      <h1>Frequently Asked Questions (FAQ)</h1>
      <h2>1. What is multido.com?</h2>
      <p>
        multido.com is a task management app that helps you organize your tasks,
        set deadlines, and manage to-do lists, including specialized book lists.
      </p>
      <h2>2. How do I set a deadline for a task?</h2>
      <p>
        Click the calendar icon within a task, select a date from the date
        picker, and the task will display a countdown in days and hours.
      </p>
      <h2>3. Where is my data stored?</h2>
      <p>
        Your data is stored locally in your browser using localStorage. You can
        export it as a JSON file using the "Save All" feature.
      </p>
      <h2>4. Can I delete my data?</h2>
      <p>
        Yes, use the "Wipe All" feature in the settings drawer to delete all
        your data. You can save a backup first using the "Save All" button in
        the Wipe All modal.
      </p>
      <h2>5. Is multido.com accessible?</h2>
      <p>
        We are committed to accessibility and strive to meet WCAG 2.1 Level AA
        standards. For more details, see our{" "}
        <a href="/accessibility-policy">Accessibility Policy</a>.
      </p>
      <h2>6. How can I contact support?</h2>
      <p>
        Reach out to us at{" "}
        <a href="mailto:support@multido.com">support@multido.com</a>. Visit our{" "}
        <a href="/contact-us">Contact Us</a> page for more options.
      </p>
    </div>
  );
}

export default FAQ;
